import { IconButton, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { useChatContext } from '@components/Chat/ChatContextProvider/ChatContextProvider';
import { ChatOutlined } from '@material-ui/icons';
import { useIsChatEnabled } from '@components/Chat/hooks/useIsChatEnabled/useIsChatEnabled';
import classNames from 'classnames';

const useStyles = makeStyles((theme) => ({
	chatButtonOutlined: {
		'padding': theme.spacing(1),
		'color': theme.palette.primary.main,
		'display': 'flex',
		'alignItems': 'center',
		'zIndex': 19000,
		'borderRadius': '50%',
		'background': theme.palette.common.white,
		'height': '50px',
		'width': '50px',
		'border': '3px solid',
		'borderColor': theme.palette.primary.main,
		'&.MuiIconButton-root:hover': {
			backgroundColor: theme.palette.common.white,
		},
	},
	chatIcon: {
		color: theme.palette.primary.main,
		fontSize: '1.6rem',
	},
	chatUnreadCount: {
		backgroundColor: theme.palette.secondary.main,
		borderRadius: '50%',
		width: '20px',
		height: '20px',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		color: theme.palette.common.white,
		fontSize: '12px',
		zIndex: 19001,
		position: 'absolute',
		top: -3,
		right: -3,
	},
}));

export interface ChatButtonProps {
	className?: string;
}

export const ChatButton = ({ className }: ChatButtonProps) => {
	const classes = useStyles();
	const { toggleShowChat, chatUnreadCount } = useChatContext();
	const { isChatEnabled } = useIsChatEnabled();

	if (!isChatEnabled) {
		return null;
	}

	return (
		<IconButton
			aria-label="chat-button"
			className={classNames(classes.chatButtonOutlined, className)}
			onClick={toggleShowChat}
			data-field="app-liveChat-chatButton"
			disableFocusRipple
		>
			{!!chatUnreadCount && chatUnreadCount > 0 && (
				<Typography className={classes.chatUnreadCount} data-testid="chat-unread-count">{chatUnreadCount}</Typography>
			)}
			<ChatOutlined className={classes.chatIcon} />
		</IconButton>
	);
}
